import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-more",
  "use": "icon-more-usage",
  "viewBox": "0 -960 960 960",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 -960 960 960\" fill=\"#ffff\" id=\"icon-more\"><path d=\"M440-440H200v-80h240v-240h80v240h240v80H520v240h-80v-240Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol